import { extendTheme } from "@mui/joy/styles";

export const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        text: {
          primary: "#171a1c",
          secondary: "#32383E",
          tertiary: "#555e68",
        },
        primary: {
          50: "#EDF3F7",
          100: "#DBE7EF",
          200: "#B8D0E0",
          300: "#95B9D0",
          400: "#669BBC",
          500: "#3E6F8E", // Primary color
          600: "#2F536A",
          700: "#1F3847",
          800: "#101C23",
        },
        secondary: {
          50: "#CCEEFF",
          100: "#80D3FF",
          200: "#4DC2FF",
          300: "#1AB0FF",
          400: "#0097E5",
          500: "#0075B2", // Secondary color
          600: "#00507A",
          700: "#003049",
          800: "#00111A",
          // Adjust the global variant tokens as you'd like.
          // The tokens should be the same for all color schemes.
          solidBg: "var(--joy-palette-secondary-400)",
          solidActiveBg: "var(--joy-palette-secondary-500)",
          outlinedBorder: "var(--joy-palette-secondary-500)",
          outlinedColor: "var(--joy-palette-secondary-700)",
          outlinedActiveBg: "var(--joy-palette-secondary-100)",
          softColor: "var(--joy-palette-secondary-800)",
          softBg: "var(--joy-palette-secondary-200)",
          softActiveBg: "var(--joy-palette-secondary-300)",
          plainColor: "var(--joy-palette-secondary-700)",
          plainActiveBg: "var(--joy-palette-secondary-100)",
        },
        neutral: {
          50: "#fbfcfe",
          100: "#f0f4f8",
          200: "#dde7ee",
          300: "#cdd7e1",
          400: "#9fa6ad",
          500: "#636b74", // Neutral color
          600: "#555e68",
          700: "#32383e",
          800: "#171a1c",
          900: "#0b0d0e",
        },
        warning: {
          50: "#FFF4E5",
          100: "#FFE8CC",
          200: "#FFD199",
          300: "#FFBA66",
          400: "#FFA333",
          500: "#FF8C00", // Warning color
          600: "#E67E00",
          700: "#CC7000",
          800: "#B36200",
          900: "#994F00",
        },
        common: {
          white: "#FFFFFF",
          black: "#000000",
        },
      },
    },
  },
});
